<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12 q-pa-xs">
        <q-input
          v-model="formData.name"
          label="Award Name (Editable in PAM)"
          v-bind="siteCFG.fields.general"
          readonly
        >
        </q-input>
      </div>
      <div class="col-12 col-sm-6 q-pa-xs">
        <q-input
          v-model="formData.shortName"
          label="Short Name"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>

      <div class="col-12 col-sm-6 q-pa-xs">
        <q-select
          label="Type"
          :options="['Player Labels', 'Other']"
          v-model="formData.type"
          v-bind="siteCFG.fields.general"
        >
        </q-select>
      </div>
      <div class="col-12 col-sm-6 q-pa-xs">
        <q-checkbox
          :true-value="1"
          :false-value="0"
          indeterminate-value="no-value"
          label="Expiry Type"
          v-model="formData.typeExpiry"
        >
        </q-checkbox>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
        data: "awards/current",
        dataLoading: "awards/currentLoading",
      }),
    },
    props: {
      id: {
        default: null,
      },
    },
    watch: {
      id: function () {
        this.init();
      },
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {
        typeExpiry: 0,
      },
      tab: "general",
    }),
    beforeCreate() {},
    mounted() {
      this.init();
      this.$store.dispatch("awards/loadByID", this.id);
    },
    methods: {
      init() {
        if (this.data != null && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {
            typeExpiry: 0,
          };
        }
      },
      save() {
        this.$emit("loadingStateChanged", true);

        this.$store.dispatch("awards/save", this.formData).then((result) => {
          this.$emit("loadingStateChanged", false);
          if (result.Result == "Success") {
            this.address = "";
            this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .formSubTitle {
    font-weight: bold;
  }
</style>
